/**
 * ResponsiveIframe
 */
import React from 'react';
import clsx from 'clsx';
/** Used to render a responsive iframe. */
var ResponsiveIframe = function (_a) {
    var src = _a.src, ariaLabel = _a["aria-label"], _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '16:9' : _b, dataConsentSrc = _a["data-consent-src"], dataCategoryConsent = _a["data-category-consent"], children = _a.children;
    return (React.createElement("div", { "data-cid": "ResponsiveIframe", className: clsx('relative overflow-hidden bg-greyLighter', aspectRatio === '16:9' ? 'iframe-16-9' : 'iframe-other') },
        React.createElement("iframe", { src: dataConsentSrc ? '' : src, "aria-label": ariaLabel, "data-consent-src": dataConsentSrc, "data-category-consent": dataCategoryConsent, className: "absolute inset-0 w-full h-full" }),
        children));
};
export default ResponsiveIframe;
